import { Select, SelectProps } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import { currentUserSortedCompaniesSelector } from '../../redux/session/currentUser/selectors'

const CurrentUserCompaniesSelect = (props: SelectProps) => {
  const companies = useSelector(currentUserSortedCompaniesSelector)

  return (
    <Select
      showSearch
      optionFilterProp="name"
      fieldNames={{ value: 'id', label: 'name' }}
      options={companies}
      {...props}
    />
  )
}

export default CurrentUserCompaniesSelect
